export const LAYER_KEY__HEAT_SOURCE_INVENTORY =
  'LAYER_KEY__HEAT_SOURCE_INVENTORY';
export const LAYER_KEY__HEAT_SOURCE_POTENTIAL =
  'LAYER_KEY__HEAT_SOURCE_POTENTIAL';
export const LAYER_KEY__HEATING_CENTER_INVENTORY =
  'LAYER_KEY__HEATING_CENTER_INVENTORY';
export const LAYER_KEY__HEATING_CENTER_POTENTIAL =
  'LAYER_KEY__HEATING_CENTER_POTENTIAL';
export const LAYER_KEY__GRID_FEED_POINT_INVENTORY =
  'LAYER_KEY__GRID_FEED_POINT_INVENTORY';
export const LAYER_KEY__GRID_FEED_POINT_POTENTIAL =
  'LAYER_KEY__GRID_FEED_POINT_POTENTIAL';

export const LAYER_KEY__WIND_POWER_PLANT = 'windpowerplant';
export const LAYER_KEY__SOLAR_FREE_POWER_PLANT = 'solarfreepowerplant';
export const LAYER_KEY__BIOMASS_POWER_PLANT = 'biomasspowerplant';
export const LAYER_KEY__GEOTHERMAL_POWER_PLANT = 'geothermalpowerplant';

export const LAYER_KEY__BLOCK = 'aggregation_buildingblock';
export const LAYER_KEY__DISTRICT = 'aggregation_district';
export const LAYER_KEY__MUNICIPALITY = 'aggregation_municipality';
export const LAYER_KEY__MUNICIPALITY_LINE = 'aggregation_municipality_line';
export const LAYER_KEY__CUSTOM_AGGREGATION = 'aggregation_custom';
export const LAYER_KEY__AGGREGATION_LEVEL_CLIENT_DATA = 'scaling_layer';

export const LAYER_KEY__COUNTY = 'aggregation_county';
export const LAYER_KEY__GOVERNMENT_DISTRICT = 'aggregation_government_district';
export const LAYER_KEY__FEDERAL_STATE = 'aggregation_federal_state';
export const LAYER_KEY__BKG_RASTER = 'aggregation_bkg_raster';
export const LAYER_KEY__HEAT_DENSITY_STREETS =
  'buildingmodel_heat_density_street_segment';
